module.exports = __webpack_public_path__ + "static/interest1-79af1793a955480a5b2d5d82a301b8ef.jpg";